













































































































































































































































































































import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'

import { NetworkService } from '@/services/NetworkService'

export default Vue.extend({
  data: () => ({
    snackbar: false,
    uploadedImages: [],
    uploadedBanners: [],
    deletedImages:[],
    snackbarText: '',
    provinces: ['Alberta', 'British Columbia', 'Manitoba', 'New Brunswick', 'Newfoundland and Labrador', 'Northwest Territories', 'Nova Scotia', 'Nunavut', 'Ontario', 'Prince Edward Island', 'Quebec', 'Saskatchewan', 'Yukon'],
    newDealer: {
      image: null,
      banners: []
    } as any,
    loading: false
  }),
  components: {
  },
  computed: {
    ...mapGetters({
      dealer: 'dealers/currentDealer',
      make: 'makes/currentMake'
    }),
    obs () : any {
      return this.$refs.observer as any
    }
  },
  methods: {
    ...mapActions({
      reloadDealer: 'dealers/loadDealer',
    }),
    async submit() {
      const isValid = await this.obs.validate()
        if (isValid) {
          this.patchDealer()
        } else {
          this.$vuetify.goTo(".error--text")
        }
    },
    patchDealer() {
      this.loading = true
      NetworkService.patch(process.env.VUE_APP_API_BASE_URL + '/api/v1/auth/dealers/' + this.newDealer.id, {
        ...this.prepareRequestJson()
      }).then(() => {
        this.snackbarText = 'Dealer saved successfully.'
        this.snackbar = true
        this.newDealer.uploadedBanners = []
        this.deletedImages = []
        this.$store.commit('dealers/setCurrentDealer', this.newDealer)
        this.loading = false
      }).catch(err => console.log(err.response.data))
    },
    prepareRequestJson () {
      const request = {
        ...this.newDealer,
        deleted_images: this.deletedImages
      }
      return request
    },
    onFileChange(file: any) : void {
      (function (file, vm) {
        var reader = new FileReader()
        reader.onload = function (e) {
          vm.newDealer.image = ({
            id: file.name,
            name: file.name,
            photo: e.target.result,
            new: true
          })
        }
        reader.readAsDataURL(file)
      })(file, this)
    },
    onBannerFileChange(files: any) : void {
      if (this.newDealer.banners) {
        for (let i = 0; i < this.newDealer.banners.length; i++) {
          if (this.newDealer.banners[i].new) {
            this.newDealer.banners.splice(i, 1)
            i--
          }
        }
      } else {
        this.newDealer.banners = []
      }

      for (let i = 0; i < files.length; i++) {
        (function(file, vm) {
          var reader = new FileReader()
          reader.onload = function(e: any) {
            vm.newDealer.banners.push({
              id: file.name + '_' + i,
              name: file.name,
              photo: e.target.result,
              new: true
            })
          }
          reader.readAsDataURL(file)
        })(files[i], this)
      }
    },
    onImageDelete(item: any) {
      for (let i = 0; i < this.newDealer.dealerBannerImages.length; i++) {
        if (this.newDealer.dealerBannerImages[i].id == item.id) {
          this.newDealer.dealerBannerImages.splice(i, 1)
          if (!item.new) {
            this.deletedImages.push(item.id)
          }
          break
        }
      }
    }
  },
  mounted() {
    this.newDealer = JSON.parse(JSON.stringify(this.dealer))
  }
})
